import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as authService from '../../services/authService';
import { useAuth } from '../../contexts/AuthContext';

interface OAuthCallbackProps {
  provider: 'vk' | 'yandex';
}

const OAuthCallback: React.FC<OAuthCallbackProps> = ({ provider }) => {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  // Получаем доступ к контексту авторизации
  const { clearError } = useAuth();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // Получаем код и state из URL параметров
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        
        if (!code) {
          setError('Код авторизации не получен');
          return;
        }
        
        // Для VK проверяем state
        if (provider === 'vk') {
          // Для VK теперь используем прямой редирект с сервера, не нужно обмениваться кодом
          // Токен должен уже присутствовать в URL
          const params = new URLSearchParams(window.location.search);
          const token = params.get('token');
          
          if (token) {
            // Сохраняем токен
            authService.saveToken(token);
            clearError();
            
            // Принудительно обновляем страницу для применения нового токена
            window.location.href = '/';
          } else {
            setError('Не удалось получить токен авторизации через ВКонтакте');
          }
          return;
        }
        
        // Для Яндекса отправляем код на сервер для получения токена
        if (provider === 'yandex') {
          const response = await authService.exchangeCodeForToken(provider, code);
          
          if (response.token) {
            // Сохраняем токен
            authService.saveToken(response.token);
            clearError();
            
            // Принудительно обновляем страницу для применения нового токена
            window.location.href = '/';
          } else {
            setError('Не удалось получить токен авторизации через Яндекс');
          }
        }
      } catch (err: any) {
        console.error(`Ошибка при обработке колбэка ${provider}:`, err);
        setError(err.message || `Ошибка при авторизации через ${provider === 'vk' ? 'ВКонтакте' : 'Яндекс'}`);
      }
    };

    handleOAuthCallback();
  }, [provider, navigate, clearError]);

  if (error) {
    return (
      <div className="oauth-callback-error">
        <h2>Ошибка авторизации</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/')}>Вернуться на главную</button>
      </div>
    );
  }

  return (
    <div className="oauth-callback-loading">
      <h2>Выполняется авторизация</h2>
      <p>Пожалуйста, подождите...</p>
    </div>
  );
};

export default OAuthCallback; 